import { render } from "./PostButton.vue?vue&type=template&id=3b8850f8"
import script from "./PostButton.vue?vue&type=script&lang=js"
export * from "./PostButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__